<template>
  <div class="svg-map-wrap" id="map-container">
    <svg
      viewbox="0 0 959 593"
      width="959px"
      height="593"
      :style="{ 'transform': `scale(${scale})` }"
    >
      <g class="state">
        <path
          v-for="(state, index) in states"
          class="state-single"
          :class="{ 'is-active': selected.includes(state[2]) }"
          :d="state[1]"
          @click="select(state[2])"
          :key="index"
        >
          <title>{{ state[2] }}</title>
        </path>
      </g>

      <g class="borders" fill="none" v-html="borders.join()"></g>
      <path class="separator" fill="none" d="m 215,493 v 55 l 36,45 m -251,-168 h 147 l 68,68 h 85 l 54,54 v 46"/>
    </svg>
  </div>  
  
  <div class="flex flex-wrap pt-6">
    <div
      class="py-2 px-5 border rounded-md mr-2 mb-2 text-sm cursor-pointer"
      v-for="(state, index) in states"
      :key="index"
      @click="select(state[2])"
      :class="{ 'bg-gray-200 border-gray-200': selected.includes(state[2]) }"
    >
      {{ state[2] }}
    </div>
  </div>
</template>

<script>
  import statesConfig from './states.js'
  import bordersConfig from './borders.js'

  import { defineComponent, ref, computed, onMounted, watch } from "vue"
  
  export default defineComponent({
    name: 'StatesControl',

    emits: ['updated'],

    setup (props, { emit }) {
      const states = ref(statesConfig)
      const borders = ref(bordersConfig)
      const isMounted = ref(false)
      const selected = ref([])
      const containerWidth = ref(959)

      const scale = computed(() => {
        if (!isMounted.value) return 0
        else return containerWidth.value / 959
      })

      onMounted(() => {
        isMounted.value = true
        containerWidth.value = document.querySelector('#map-container').offsetWidth

        window.addEventListener('resize', () => {
          containerWidth.value = document.querySelector('#map-container').offsetWidth
        })
      })

      watch(selected, (newValue, oldValue) => {
        emit('updated', selected.value)
      }, { deep: true })

      const select = (state) => {
        if (selected.value.includes(state)) {
          selected.value = selected.value.filter(option => option !== state)
        } else {
          selected.value.push(state)
        }
      }

      const selectAll = () => {
        selected.value = states.value.map(state => state[2])
      }

      return {
        states,
        borders,
        isMounted,
        selected,
        containerWidth,
        scale,
        select,
        selectAll
      }
    }
  })
</script>

<style scoped>
  .svg-map-wrap {
    width: 100%;
    padding-top: 62%;
    position: relative;
    overflow: hidden;
  }
  .svg-map-wrap svg {
    position: absolute;
    top: 0;
    left: 0;
    transform-origin: top left;
  }

  .svg-map-wrap svg .state-single {
    fill: lightgrey;
    transition: .2s ease-in-out;
    cursor: pointer;
  }

  .svg-map-wrap svg .state-single:hover {
    fill: #5484B8;
  }

  .svg-map-wrap svg .state-single.is-active {
    fill: #5484B8 !important;
  }

  .separator {
    stroke: black;
  }

  .borders {
    stroke: white;
  }

  .selection {
    padding-top: 30px;
  }

  .selection .btn {
    margin-left: 16px;
  }
</style>